export { NotificationEntity as default };

/**
* Notification Entity
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class NotificationEntity {
  /**
   * Notification Id
   *
   * @public
   *
   * @type {string|null}
   *
   * @since 7.0.0
   */
  id = null;

  /**
   * Notification type
   *
   * @public
   *
   * @type {string|null}
   *
   * @since 7.0.0
   */
  type = null;

  /**
   * Notification message
   *
   * @public
   *
   * @type {string}
   *
   * @since 7.0.0
   */
  message;

  /**
   * Notification Replacements
   *
   * @public
   *
   * @type {Array}
   *
   * @since 7.0.0
   */
  replacements;

  /**
   * Auto Dismiss in Notify
   *
   * @public
   *
   * @type {Boolean}
   *
   * @since 7.0.0
   */
  auto_dismiss = true;

  /**
   * Allows the message to be duplicated
   *
   * @public
   *
   * @type {Boolean}
   *
   * @since 7.0.0
   */
  allow_duplicates = false;

  /**
   * Type of message eg: text, link_text ...
   *
   * @public
   *
   * @type {String}
   *
   * @since 7.0.0
   */
  message_type = 'text';

  /**
   * URL to redirect
   *
   * @public
   *
   * @type {String|Null}
   *
   * @since 7.0.0
   */
  link = null;

  /**
   * Type Link external eg: external ou internal
   *
   * @public
   *
   * @type {String|Null}
   *
   * @since 7.0.0
   */
  link_type = null;

  /**
   * Class to insert in button link
   *
   * @public
   *
   * @type {String|Null}
   *
   * @since 7.0.0
   */
  link_class = null;

  /**
   * Text used in Link
   *
   * @public
   *
   * @type {String|Null}
   *
   * @since 7.0.0
   */
  link_text = null;

  /**
   * Icon to use in Link
   *
   * @public
   *
   * @type {String|Null}
   *
   * @since 7.0.0
   */
  link_icon = null;
}